export class Direction {
    iddirection: number;
    direction: string;
    idpole: number;
    societe: number;
    statut: number;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/direction.ts